import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  callback: null,
  condition: false,
  hideDescription: false
};

const leavePageModalSlice = createSlice({
  name: "showLeavePageModalSlice",
  initialState,
  reducers: {
    setLeavePageModalState(state, action) {
      state.show = action.payload.show;
      state.callback = action.payload.callback;
      state.condition = action.payload.condition;
      state.hideDescription = action.payload.hideDescription;
    }
  }
});

export const { setLeavePageModalState } = leavePageModalSlice.actions;

export default leavePageModalSlice.reducer;
